import * as z from "zod";

export const updateSubscribeKeyword = {
  name: "updateSubscribeKeyword" as const,
  input: z.object({
    id: z.string(),
    keyword: z
      .string()
      .min(3)
      .max(20)
      .regex(/^[A-Z0-9]+$/)
      .optional(),
    tagLegacyIds: z.array(z.string()).optional(),
    status: z.enum(["active", "inactive"]).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
